<template>
  <div>
    <div class="flex justify-between border-b border-dark-b text-xl md:text-2xl font-medium">
      <div>
        My Draft Orders
        <span v-if="getTotalDraftsCount !== null">
          ({{ draftOrders.length ? getTotalDraftsCount : 0 }})
        </span>
      </div>
    </div>
    <div v-if="draftOrders && draftOrders.length" class="text-xs lg:text-base bg-white rounded-lg px-5 mt-5 pb-5">
      <div class="py-5 flex flex-wrap lg:flex-no-wrap justify-between font-semibold border-b">
        <div class="w-3/12 lg:w-2/12">Draft Created on:</div>
        <div class="w-3/12 lg:w-2/12 lg:pl-2">Order Number:</div>
        <div class="w-5/12 lg:pl-4">Product Category & sub-Category:</div>
        <div class="w-full lg:w-4/12 pt-2 lg:pt-0 lg:text-right">
          <button
            @click="isDeleteAllModalOpen = true"
            class="text-blue underline text-base"
          >
            Delete all drafts
          </button>
        </div>
      </div>
      <div
        v-for="order in draftOrders"
        :key="order.id_token"
        class="py-5 flex justify-between border-b flex-wrap lg:flex-no-wrap"
      >
        <div class="flex flex-wrap w-3/12 lg:w-2/12">
          {{ order.draft_created_on }}
        </div>
        <div class="flex flex-wrap w-3/12 lg:w-2/12 lg:pl-2">
          {{ order.draft_order_number }}
        </div>
        <div class="w-5/12 lg:pl-4">
          <div class="flex flex-wrap">
            Product Category: {{ order.product_category_name }}
          </div>
          <div class="flex flex-wrap">
            Sub-Category: {{ order.product_sub_category_name }}
          </div>
        </div>
        <div class="flex items-center w-full lg:w-4/12 justify-between lg:justify-end xl:text-xl pt-4 lg:pt-0">
          <button
            class="inline-flex items-center rounded-full bg-gray-650 text-white px-3 font-semibold"
            style="height: 2.625rem"
            @click="editOrderDraft(order.id_token)"
          >
            Continue editing
          </button>
          <button @click="openDeleteModal(order)" class="ml-8 text-theme text-2xl">
            <i class="icon-remove"/>
          </button>
        </div>
      </div>
      <AppModal
        v-if="isDeleteModalOpen || isDeleteAllModalOpen"
        width="500px"
        @close="closeModal"
      >
        <div slot="content">
          <h1 class="text-center text-sm">
            <template v-if="isDeleteModalOpen">
              Are you sure you want to delete this draft?
            </template>
            <template v-else-if="isDeleteAllModalOpen">
              Are you sure you want to delete all drafts?
            </template>
          </h1>
          <div class="flex justify-center pt-7">
            <button
              @click="onDeleteConfirm"
              class="h-8 w-16 text-white text-sm bg-blue rounded-full mr-1"
            >
              Yes
            </button>
            <button
              @click="closeModal"
              class="h-8 w-16 text-white text-sm bg-theme rounded-full ml-1"
            >
              No
            </button>
          </div>  
        </div>
      </AppModal>
    </div>
    <div v-if="!draftOrders[0]" class="bg-white rounded-lg px-5 mt-5 pb-5">
      <p class="text-center text-3xl p-12 font-bold">No Drafts</p>
    </div>
    <div class="flex lg:justify-end justify-center pt-6">
      <router-link 
        class="bg-blue text-white rounded-full py-3 px-8 text-lg lg:text-xl font-bold"
        to="/profile/my-orders"
      >
        Back
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'MyDraftOrders',
  data() {
    return {
      isDeleteModalOpen: false,
      isDeleteAllModalOpen: false,
      selectedOrder: null,
      draftOrders: [],
      totalDrafts: 0,
    }
  },

  created() {
    this.getDraftOrders()
  },

  computed: {
    ...mapGetters (['getTotalDraftsCount']),
  },

  methods: {
    ...mapMutations ([
      'setSourcingRequestToken'
    ]),
    ...mapActions ([
      'fetchDraftOrders',
      'deleteDraftOrders',
      'deleteAllDrafts',
      'changeTotalDraftsCount'
    ]),
    editOrderDraft(order) {
      this.setSourcingRequestToken(order)
      this.$router.push({ name: 'Sourcing Request', query: { editing: true }})
    },
    openDeleteModal(order) {
      this.selectedOrder = order
      this.isDeleteModalOpen = true
    },
    closeModal() {
      this.isDeleteModalOpen = false
      this.selectedOrder = null
      this.isDeleteAllModalOpen = false
    },
    async onDeleteConfirm() {
      const response = this.isDeleteAllModalOpen
        ? await this.deleteAllDrafts()
        : await this.deleteDraftOrders(this.selectedOrder.id_token)

      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message
      })

      if (response.result) {
        if (this.isDeleteAllModalOpen) {
          this.draftOrders = []
          this.changeTotalDraftsCount(0)
        } else this.removeSelectedOrder()
      }

      this.closeModal()
    },

    removeSelectedOrder() {
      const index = this.draftOrders.findIndex(order => order === this.selectedOrder)
      this.draftOrders.splice(index, 1)
      this.changeTotalDraftsCount(this.getTotalDraftsCount - 1)

      return this.draftOrders
    },

    async getDraftOrders() {
      const response  = await this.fetchDraftOrders('data')
      if (response.result){
        this.draftOrders = response.orders
        this.changeTotalDraftsCount(response.total_results)
      }
    }
  }
}
</script>
